import { MapPin, Clock, Mail } from "lucide-react";
import { content } from "@/lib/content";
import { useLanguage } from "@/lib/language";

export function TopBar() {
  const { t } = useLanguage();
  return (
    <div className="bg-topbar text-topbar-foreground text-xs sm:text-sm">
      <div className="mx-auto flex max-w-none w-full flex-wrap items-center justify-center gap-x-6 gap-y-1 px-4 lg:px-8 py-2 text-center sm:justify-between">
        <span className="inline-flex items-center gap-1.5">
          <MapPin className="size-3.5 text-primary" />
          {t(content.topbar.location)}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <Clock className="size-3.5 text-primary" />
          {t(content.topbar.hours)}
        </span>
        <a
          href={`mailto:${content.topbar.email.en}`}
          className="inline-flex items-center gap-1.5 transition-colors hover:text-primary"
        >
          <Mail className="size-3.5 text-primary" />
          {t(content.topbar.email)}
        </a>
      </div>
    </div>
  );
}
